import { RoleProtected } from '../Components/RoleProtected';
import CannyListView from '../Components/CannyListPageComp/Views/CannyListView';

export default function CannyListPage() {
  return (
    <RoleProtected allowedRoles={["user", "Admin"]} showPageAction="canny_manager_view">
      <CannyListView />
    </RoleProtected>
  );
}